module.exports = __webpack_public_path__ + "img/mynews24-header.ebe486df.png";